export type CameraResolution = 'max' | { width: number; height: number };
export type OutputResolution = 'source' | { width: number; height: number };

export interface ContinuousCameraConfig {
  cameraResolution?: CameraResolution;
  outputResolution?: OutputResolution;
  jpegQuality?: number;
  showSettings?: boolean;
  shutterSound?: boolean;
  showCaptureCount?: boolean;
  maxCaptures?: number | null;
  continuous?: boolean;
  enableSoftwareZoom?: boolean;
}

export interface CapturedImage {
  blob: Blob;
  width: number;
  height: number;
  mimeType: string;
  size: number;
  capturedAt: string;
  zoom: number;
  /** 呼び出し側の保存処理が返すファイル名等。削除コールバックへ引き継がれる。 */
  storageId?: string;
}

export interface ContinuousCameraSaveResult {
  storageId?: string;
}

export type ContinuousCameraSaveHandler = (image: CapturedImage) => Promise<ContinuousCameraSaveResult | void>;
export type ContinuousCameraDeleteHandler = (image: CapturedImage) => Promise<void>;

export const DEFAULT_CONTINUOUS_CAMERA_CONFIG: Required<Omit<ContinuousCameraConfig, 'maxCaptures'>> & Pick<ContinuousCameraConfig, 'maxCaptures'> = {
  cameraResolution: 'max',
  outputResolution: { width: 1920, height: 1080 },
  jpegQuality: 0.95,
  showSettings: false,
  shutterSound: true,
  showCaptureCount: true,
  maxCaptures: undefined,
  continuous: true,
  enableSoftwareZoom: true,
};
